/*----------------------
       VALUES
---------------------- */
Values = {
    init: function () {
        if ($(window).width() > 768) {
            $(".btn-value span").on("mouseenter", function () {
                var value = $(this).data("value");
                $(".values-descriptions").removeClass("open");
                $(".description-" + value).addClass("open");
                $(".btn-value span").removeClass("current");
                $(this).addClass("current");
            });
            $(".btn-value span").on("click", function () {
                var value = $(this).data("value");
                $(".description-" + value).toggleClass("open");
                $(".btn-value span").removeClass("current");
                $(this).addClass("current");
            });

            $("body").on("click", function (e) {
                if (!$(e.target).closest('.btn-value, .values-descriptions').length) {
                    $(".btn-value span").removeClass("current");
                    $(".values-descriptions").removeClass("open")
                }
            });
        }
        else {
            $(".btn-value span").on("click", function () {
                var parent = $(this).closest(".btn-value--wrapper");
                $('.btn-value--wrapper').not(parent).removeClass("open");
                parent.toggleClass("open");

                $('btn-value span').not(this).removeClass("current");
                $(this).toggleClass("open");

            });
            $("body").on("click", function (e) {
                if (!$(e.target).closest('.btn-value, .value-description--mobile').length) {
                    $(".btn-value--wrapper").removeClass("open");
                    $(".btn-value span").removeClass("current");
                }
            });

        }
    }
};

$(document).ready(function () {
    Values.init();
});
$(document).on('shopify:section:load', function (event) {
    Values.init();
});